import { Box, Typography } from "@mui/material";
import ToleranceGeneralWidget from "../Widgets/Tolerance/General/General";

const Home = () => {
  return (
    <Box >
      <Typography m={3} variant="h3">Home</Typography>

      <ToleranceGeneralWidget />
    </Box>
  );
};

export default Home;
